import { InfoElementType } from 'Hooks/use-toolbar'
import classes from './InformationContainer.module.less'
import React from 'react'

type InfoElementsByAlignmentType = {
    left: React.ReactElement[]
    center: React.ReactElement[]
    right: React.ReactElement[]
}

type InformationContainerProps = {
    infoElements: InfoElementType[]
}

export const InformationContainer = (InformationContainerProps: InformationContainerProps) => {
    const elementsByAlignment: InfoElementsByAlignmentType =
        InformationContainerProps.infoElements.reduce(
            (acc, infoElement) => {
                const elementWithKey = React.cloneElement(infoElement.element, {
                    key: `${infoElement.id}`,
                })
                if (infoElement.alignment === 'left') {
                    acc.left.push(elementWithKey)
                } else if (infoElement.alignment === 'center') {
                    acc.center.push(elementWithKey)
                } else {
                    acc.right.push(elementWithKey)
                }
                return acc
            },
            { left: [], center: [], right: [] } as InfoElementsByAlignmentType
        )
    return (
        <div className={classes.infoContainer}>
            <div key={'left'} className={classes.infoElementLeft}>
                {elementsByAlignment.left}
            </div>
            <div key={'right'} className={classes.infoElementCenter}>
                {elementsByAlignment.center}
            </div>
            <div key={'center'} className={classes.infoElementRight}>
                {elementsByAlignment.right}
            </div>
        </div>
    )
}
